import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'SalesOrderAllocation',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SalesOrderAllocation',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SalesOrderAllocation',
    column_type: 'datetime',
  },
  source: {
    model_name: 'SalesOrderAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'source',
      model_name: 'SalesOrder',
    },
  },
  source_id: {
    model_name: 'SalesOrderAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'source',
      model_name: 'SalesOrder',
    },
  },
  target: {
    model_name: 'SalesOrderAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: 'SalesOrder',
    },
  },
  target_id: {
    model_name: 'SalesOrderAllocation',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: 'SalesOrder',
    },
  },
  amount: {
    model_name: 'SalesOrderAllocation',
    column_type: 'decimal',
  },
  allocated_on: {
    model_name: 'SalesOrderAllocation',
    column_type: 'date',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
